export default __webpack_public_path__ + "static/media/folder.03348d70.svg";